import { ACCOUNTS_SEARCH, NOT_APPROVED_ACCOUNTS_SEARCH } from 'constants/action-types';
import { DEFAULT_MYAUCTION_LIST_LENGTH } from 'constants/auctions';

export const pagination = {
  recordsReturned: null,
  totalRecordsFound: null,
  currentPage: 1,
  recordsPerPage: DEFAULT_MYAUCTION_LIST_LENGTH
};

const initialState = {
  isLoading: false,
  approvedAccounts: [],
  filters: {},
  notApprovedAccounts: [],
  pagination
};

export const accounts = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNTS_SEARCH.pending:
      return {
        ...state,
        isLoading: true
      };
    case ACCOUNTS_SEARCH.success:
      return {
        ...state,
        isLoading: false,
        approvedAccounts: action.payload.registrations,
        filters: action.payload.request,
        pagination: action.payload.pagination
      };
    case NOT_APPROVED_ACCOUNTS_SEARCH.success:
      return {
        ...state,
        notApprovedAccounts: action.payload
      };
    default:
      return state;
  }
};
